<template>
    <div class="monitor">
        <!-- 标题内容 -->
        <header>
            <div class="header-left">
                <!-- 模块名称 -->
                <div class="name">园区监控</div>
                <!-- 温室选择 -->
                <Dropdown class="list" @on-click="handleRoomChange">
                    <div class="dropdown-title">
                        <span class="dropdown-name">{{ roomName }}</span>
                        <Icon class="dropdown-icon" type="md-arrow-dropdown" />
                    </div>
                    <DropdownMenu class="dropdown-list" slot="list">
                        <DropdownItem v-for="item in getRoomList" :name="item.id" :key="item.id">{{
                            item.nick_name
                        }}</DropdownItem>
                    </DropdownMenu>
                </Dropdown>
                <!-- 设备选择 -->
                <Dropdown class="list" @on-click="handleMonitorChange">
                    <div class="dropdown-title">
                        <span class="dropdown-name">{{ getCameraName }}</span>
                        <Icon class="dropdown-icon" type="md-arrow-dropdown" />
                    </div>
                    <DropdownMenu class="dropdown-list" slot="list">
                        <DropdownItem
                            v-for="(item, index) in getMonitorList"
                            :name="index"
                            :key="index"
                            >{{ item.device_name }}</DropdownItem
                        >
                    </DropdownMenu>
                </Dropdown>
            </div>
            <!-- 设备总数 -->
            <div class="monitor-des">
                <img class="monitor-icon" src="../assets/camera.png" />
                <div class="monitor-text">设备总数</div>
                <div class="monitor-count">{{ getMonitorList.length }}</div>
            </div>
        </header>
        <!-- 加载动画 -->
        <Spin class="loading" v-show="loading">
            <div class="loading-container">
                <Icon type="ios-loading" size="18" class="demo-spin-icon-load"></Icon>
                <div class="loading-text">加载中</div>
            </div>
        </Spin>
        <!-- 监控内容 -->
        <div class="content">
            <abstractCamera
                v-if="currentCameraInfo && currentCameraInfo.hls"
                :cameraInfo="currentCameraInfo" />
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { conversionTimeFormat } from "../utils/tool";
import localstore from "../utils/localStorge";
import abstractCamera from "./camera/abstractCamera.vue";

export default {
    name: "monitor",
    components: {
        abstractCamera
    },
    data() {
        return {
            room: "",
            roomName: "",
            montiorName: "",
            loading: true,
            currentCameraInfo: null
        };
    },
    async mounted() {
        await this.roomList();
        // 获取初始room_id
        this.room = this.$store.state.roomId;
        // 设置roomName初始值
        const roomIndex = this.$store.state.roomList.findIndex(item => item.id === this.room);
        if (roomIndex !== -1) {
            this.roomName = this.$store.state.roomList[roomIndex].nick_name;
        } else {
            this.roomName = "无园区";
        }
        if (this.room !== null) {
            // 获取该room下全部的监控设备
            this.monitorList({
                roomId: this.room
            }).then(data => {
                // console.log(data);
                // 监控设备列表
                this.$store.commit("monitor/setMonitorList", {
                    monitorList: data
                });
                // 设置monitorName初始值
                if (data.length === 0) {
                    this.setCurrentCamera(null);
                } else {
                    if (localstore.get("motior") === null) {
                        this.setCurrentCamera(this.$store.state.monitor.monitorList[0]);
                    } else {
                        let index = localstore.get("motior");
                        if (this.$store.state.monitor.monitorList.length <= index) {
                            index = 0;
                        }
                        this.setCurrentCamera(this.$store.state.monitor.monitorList[index]);
                    }
                }
                this.loading = false;
            });
        }
    },
    computed: {
        ...mapGetters("monitor", ["getMonitorList"]),
        ...mapGetters(["getRoomList"]),
        getCameraName: function() {
            if (this.currentCameraInfo) {
                return this.currentCameraInfo.device_name;
            } else {
                return "无监控";
            }
        }
    },
    methods: {
        setCurrentCamera(camera) {
            this.currentCameraInfo = null;
            this.$nextTick(() => {
                this.currentCameraInfo = camera;
            });
        },
        ...mapActions(["roomList"]),
        ...mapActions("monitor", ["monitorList"]),
        handleRoomChange(roomId) {
            if (roomId !== this.room) {
                // 删除上一次保存的监控id
                localstore.remove("motior");
                this.room = roomId;
                // 设置显示的园区名称
                const roomIndex = this.$store.state.roomList.findIndex(item => item.id === roomId);
                if (roomIndex !== -1) {
                    this.roomName = this.$store.state.roomList[roomIndex].nick_name;
                }
                this.$store.commit("setRoomId", {
                    roomId: roomId
                });
            }
            if (roomId !== null) {
                this.monitorList({
                    roomId: roomId
                }).then(data => {
                    this.$store.commit("monitor/setMonitorList", {
                        monitorList: data
                    });
                    if (data.length > 0) {
                        // 查看缓存中是否有motior
                        if (localstore.get("motior") === null) {
                            this.setCurrentCamera(this.$store.state.monitor.monitorList[0]);
                            localstore.set("motior", 0);
                        } else {
                            let index = localstore.get("motior");
                            if (this.$store.state.monitor.monitorList.length <= index) {
                                index = 0;
                            }
                            this.setCurrentCamera(this.$store.state.monitor.monitorList[index]);
                        }
                    } else {
                        this.setCurrentCamera(null);
                    }
                });
            }
        },
        handleMonitorChange(index) {
            localstore.set("motior", index);
            this.setCurrentCamera(this.$store.state.monitor.monitorList[index]);
        },
        conversionTimeFormat: conversionTimeFormat
    }
};
</script>

<style scoped>
.monitor {
    position: absolute;
    top: 20px;
    right: 20px;
    width: 26.615vw;
    height: calc((100% - 80px) / 3);
    background-color: rgba(0, 40, 69, 0.8);
    border-radius: 0.5vw;
    overflow: hidden;
}

header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    width: 100%;
    height: 20%;
}

.header-left {
    display: flex;
    align-items: center;
}

.name {
    font-size: 1.172vw;
    color: #ffffff;
    padding-left: 1vw;
}

.monitor-des {
    display: flex;
    align-items: center;
    padding-right: 1vw;
}

.monitor-icon {
    width: 1vw;
    height: 1vw;
    margin-right: 0.3vw;
}

.monitor-text {
    color: #02bae1;
    font-size: 0.8vw;
}

.monitor-count {
    color: #ffffff;
    font-size: 1vw;
    padding-left: 0.3vw;
}

.content {
    position: relative;
    width: calc(100% - 2.2vw);
    height: calc(80% - 1vw);
    background: url("./../assets/monitor-background.png");
    background-size: 100% 100%;
    margin-left: 1.1vw;
    margin-right: 1.1vw;
    margin-bottom: 1vw;
}

.loading {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.loading-container {
    display: flex;
    align-items: center;
}

.loading-text {
    font-size: 0.6vw;
    padding-left: 0.2vw;
}

.list {
    margin-left: 0.5vw;
    width: 6.4vw;
    background-color: #000c15;
    padding: 0.1vw 0.3vw;
}

.list >>> .ivu-select-dropdown {
    background-color: #000c15;
    margin: 8px 0px;
    padding: 0px;
}

.ivu-dropdown-item {
    color: #ffffff;
    padding: 0.1vw 0.3vw;
    width: 6.4vw;
    font-size: 0.6vw !important;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

.ivu-dropdown-item:hover {
    background-color: rgba(255, 255, 255, 0.2);
}

.dropdown-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.dropdown-name {
    max-width: 6vw;
    font-size: 0.6vw;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

.dropdown-icon {
    font-size: 1vw;
    color: #00cdff;
}

.dropdown-list {
    max-height: 4vw;
    overflow-y: auto;
    overflow-x: hidden;
    background-color: #000c15;
}
</style>
